import { Link } from "react-router-dom";

const related = [
  {
    id: 1,
    label: "Living Rooms",
    title: "Soft Beige Living Room Ideas That Feel Calm and Expensive",
    excerpt: "A complete guide to building a warm, layered beige living room from the sofa outward.",
    path: "/living-room/soft-beige",
    image: "https://public.readdy.ai/ai/img_res/2028d0e629bac251220f1fe18c6bd46c.jpg",
  },
  {
    id: 2,
    label: "Cozy Corners",
    title: "How to Create a Calm Reading Corner at Home",
    excerpt: "Soft armchairs, warm light, and a shelf of favourite books — the essentials of a perfect reading nook.",
    path: "/cozy-corners/reading-corner",
    image: "https://readdy.ai/api/search-image?query=reading%20corner%20linen%20armchair%20warm%20floor%20lamp%20books%20stacked%20small%20side%20table%20knit%20throw%20cream%20beige%20neutral%20tones%20calm%20editorial%20photography&width=800&height=500&seq=bss_rel2&orientation=landscape",
  },
  {
    id: 3,
    label: "Style Guide",
    title: "The Calm Room Style Guide",
    excerpt: "Colours, materials, and principles for designing a room that feels genuinely restful.",
    path: "/style-guide",
    image: "https://readdy.ai/api/search-image?query=calm%20neutral%20interior%20style%20guide%20warm%20beige%20tones%20natural%20materials%20linen%20wood%20ceramic%20editorial%20photography%20minimal%20elegant&width=800&height=500&seq=bss_rel3&orientation=landscape",
  },
  {
    id: 4,
    label: "Living Rooms",
    title: "Small Apartment, Soft Neutrals",
    excerpt: "How to make a compact space feel calm, open, and beautifully considered with a warm neutral palette.",
    path: "/living-room/small-apartment-soft-neutrals",
    image: "https://readdy.ai/api/search-image?query=small%20apartment%20living%20room%20soft%20neutral%20palette%20cream%20beige%20warm%20ivory%20minimal%20furniture%20natural%20light%20linen%20sofa%20compact%20elegant%20editorial%20interior%20photography%20serene%20calm%20atmosphere&width=800&height=500&seq=bss_rel4&orientation=landscape",
  },
];

export default function BSSRelated() {
  return (
    <section className="py-20 px-8 md:px-16 bg-[#F5F1E8]">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-14">
          <p
            className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Keep Reading
          </p>
          <h2
            className="text-[#2C2825] text-2xl md:text-3xl"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            Related Articles
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {related.map((article) => (
            <Link
              key={article.id}
              to={article.path}
              className="group flex flex-col cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-2xl mb-5 aspect-[16/10]">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
              </div>
              <span
                className="text-[#B5A898] text-[9px] tracking-[0.35em] uppercase mb-2"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {article.label}
              </span>
              <h3
                className="text-[#2C2825] text-base md:text-lg leading-snug mb-3 group-hover:text-[#6B5E53] transition-colors duration-200"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
              >
                {article.title}
              </h3>
              <p
                className="text-[#8B8378] text-sm leading-relaxed"
                style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
              >
                {article.excerpt}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
